import React from 'react'


import { Separator } from '@components/Separator'
import { useFindProfile } from '@hooks/profile'
import {version} from '../../../../../package.json'

import { InfoContainer, Label, SectionTitle, SubTitle } from './styles'

export function AppInformation() {
  const { data: rawUser } = useFindProfile()
  const user = rawUser ?? ({} as NonNullable<typeof rawUser>)

  return (
    <>
      <SectionTitle>App Information</SectionTitle>
      <Separator mb={10} />

      <InfoContainer>
        <SubTitle>App Version</SubTitle>
        <Label>{version || 'not found'}</Label>
      </InfoContainer>
      <>
        {user.isGlobalAdmin && (
          <>
            <InfoContainer>
              <SubTitle>App Build Version</SubTitle>
              <Label>{import.meta.env.VITE_APP_BUILD || '1'}</Label>
            </InfoContainer>
            <InfoContainer>
              <SubTitle>App ID</SubTitle>
              <Label>{import.meta.env.VITE_APP_ID || 'com.dws.next'}</Label>
            </InfoContainer>
          </>
        )}
      </>
    </>
  )
}
